export const SELF_ASSESSMENT_START_TIME = "self-assessment-start-time";
export const SELF_ASSESSMENT_START_CAT_TIME = "self-assessment-start-cat-time";
export const SELF_ASSESSMENT_START_CAT_ID = "self-assessment-start-cat-id";

export const SELF_ASSESSMENT_BEGAN_STATE = 0;
export const SELF_ASSESSMENT_FINISHED_STATE = 1;
export const SELF_ASSESSMENT_USER_REGISTERED_STATE = 2;

export const SELF_ASSESSMENT_SKIP_LANDING_PAGE = "1";
